let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gK4kH")).then(() => parcelRequire('g3o8b'));